// action types
import { createRequestTypes } from "../../utils";

// Fetch task alerts
export const FETCH_TASK_ALERTS = createRequestTypes("FETCH_TASK_ALERTS");
export const FETCH_TASK_ALERT_DETAIL = createRequestTypes("FETCH_TASK_ALERT_DETAIL");
export const FETCH_TASK_ALERT_SUMMARY = createRequestTypes("FETCH_TASK_ALERT_SUMMARY");
export const FETCH_UPCOMING_TASK_ALERTS = createRequestTypes("FETCH_UPCOMING_TASK_ALERTS");

// Create/Update/Delete task alert
export const CREATE_TASK_ALERT = createRequestTypes("CREATE_TASK_ALERT");
export const UPDATE_TASK_ALERT = createRequestTypes("UPDATE_TASK_ALERT");
export const DELETE_TASK_ALERT = createRequestTypes("DELETE_TASK_ALERT");

// Task alert lifecycle
export const COMPLETE_TASK_ALERT = createRequestTypes("COMPLETE_TASK_ALERT");
export const DISMISS_TASK_ALERT = createRequestTypes("DISMISS_TASK_ALERT");
export const REOPEN_TASK_ALERT = createRequestTypes("REOPEN_TASK_ALERT");
export const UPDATE_OVERDUE_ALERTS = createRequestTypes("UPDATE_OVERDUE_ALERTS");

// Alert templates
export const FETCH_ALERT_TEMPLATES = createRequestTypes("FETCH_ALERT_TEMPLATES");
export const FETCH_ALERT_TEMPLATE_DETAIL = createRequestTypes("FETCH_ALERT_TEMPLATE_DETAIL");
export const CREATE_ALERT_TEMPLATE = createRequestTypes("CREATE_ALERT_TEMPLATE");
export const UPDATE_ALERT_TEMPLATE = createRequestTypes("UPDATE_ALERT_TEMPLATE");
export const DELETE_ALERT_TEMPLATE = createRequestTypes("DELETE_ALERT_TEMPLATE");
export const FETCH_GENERAL_TEMPLATES = createRequestTypes("FETCH_GENERAL_TEMPLATES");

// UI State
export const SET_TASK_ALERT_FILTERS = 'SET_TASK_ALERT_FILTERS';
export const CLEAR_TASK_ALERT_DETAIL = 'CLEAR_TASK_ALERT_DETAIL';

// ==================== TASK ALERTS ====================

export const fetchTaskAlertsRequest = (filters = {}) =>
    ({ type: FETCH_TASK_ALERTS.REQUEST, payload: filters });

export const fetchTaskAlertsSuccess = (alerts) =>
    ({ type: FETCH_TASK_ALERTS.SUCCESS, payload: alerts });

export const fetchTaskAlertsFailure = (error) =>
    ({ type: FETCH_TASK_ALERTS.FAILURE, payload: error });

export const fetchTaskAlertDetailRequest = (alertId) =>
    ({ type: FETCH_TASK_ALERT_DETAIL.REQUEST, payload: { alertId } });

export const fetchTaskAlertDetailSuccess = (alert) =>
    ({ type: FETCH_TASK_ALERT_DETAIL.SUCCESS, payload: alert });

export const fetchTaskAlertDetailFailure = (error) =>
    ({ type: FETCH_TASK_ALERT_DETAIL.FAILURE, payload: error });

export const fetchTaskAlertSummaryRequest = (organizationId = null) =>
    ({ type: FETCH_TASK_ALERT_SUMMARY.REQUEST, payload: { organizationId } });

export const fetchTaskAlertSummarySuccess = (summary) =>
    ({ type: FETCH_TASK_ALERT_SUMMARY.SUCCESS, payload: summary });

export const fetchTaskAlertSummaryFailure = (error) =>
    ({ type: FETCH_TASK_ALERT_SUMMARY.FAILURE, payload: error });

export const fetchUpcomingTaskAlertsRequest = (days = 7, organizationId = null) =>
    ({ type: FETCH_UPCOMING_TASK_ALERTS.REQUEST, payload: { days, organizationId } });

export const fetchUpcomingTaskAlertsSuccess = (alerts) =>
    ({ type: FETCH_UPCOMING_TASK_ALERTS.SUCCESS, payload: alerts });

export const fetchUpcomingTaskAlertsFailure = (error) =>
    ({ type: FETCH_UPCOMING_TASK_ALERTS.FAILURE, payload: error });

export const createTaskAlertRequest = (alertData) =>
    ({ type: CREATE_TASK_ALERT.REQUEST, payload: alertData });

export const createTaskAlertSuccess = (alert) =>
    ({ type: CREATE_TASK_ALERT.SUCCESS, payload: alert });

export const createTaskAlertFailure = (error) =>
    ({ type: CREATE_TASK_ALERT.FAILURE, payload: error });

export const updateTaskAlertRequest = (alertId, alertData) =>
    ({ type: UPDATE_TASK_ALERT.REQUEST, payload: { alertId, alertData } });

export const updateTaskAlertSuccess = (alert) =>
    ({ type: UPDATE_TASK_ALERT.SUCCESS, payload: alert });

export const updateTaskAlertFailure = (error) =>
    ({ type: UPDATE_TASK_ALERT.FAILURE, payload: error });

export const deleteTaskAlertRequest = (alertId) =>
    ({ type: DELETE_TASK_ALERT.REQUEST, payload: { alertId } });

export const deleteTaskAlertSuccess = (alertId) =>
    ({ type: DELETE_TASK_ALERT.SUCCESS, payload: { alertId } });

export const deleteTaskAlertFailure = (error) =>
    ({ type: DELETE_TASK_ALERT.FAILURE, payload: error });

export const completeTaskAlertRequest = (alertId, notes = '') =>
    ({ type: COMPLETE_TASK_ALERT.REQUEST, payload: { alertId, notes } });

export const completeTaskAlertSuccess = (alert) =>
    ({ type: COMPLETE_TASK_ALERT.SUCCESS, payload: alert });

export const completeTaskAlertFailure = (error) =>
    ({ type: COMPLETE_TASK_ALERT.FAILURE, payload: error });

export const dismissTaskAlertRequest = (alertId) =>
    ({ type: DISMISS_TASK_ALERT.REQUEST, payload: { alertId } });

export const dismissTaskAlertSuccess = (alert) =>
    ({ type: DISMISS_TASK_ALERT.SUCCESS, payload: alert });

export const dismissTaskAlertFailure = (error) =>
    ({ type: DISMISS_TASK_ALERT.FAILURE, payload: error });

export const reopenTaskAlertRequest = (alertId) =>
    ({ type: REOPEN_TASK_ALERT.REQUEST, payload: { alertId } });

export const reopenTaskAlertSuccess = (alert) =>
    ({ type: REOPEN_TASK_ALERT.SUCCESS, payload: alert });

export const reopenTaskAlertFailure = (error) =>
    ({ type: REOPEN_TASK_ALERT.FAILURE, payload: error });

export const updateOverdueAlertsRequest = () =>
    ({ type: UPDATE_OVERDUE_ALERTS.REQUEST });

export const updateOverdueAlertsSuccess = (result) =>
    ({ type: UPDATE_OVERDUE_ALERTS.SUCCESS, payload: result });

export const updateOverdueAlertsFailure = (error) =>
    ({ type: UPDATE_OVERDUE_ALERTS.FAILURE, payload: error });

// ==================== ALERT TEMPLATES ====================

export const fetchAlertTemplatesRequest = (filters = {}) =>
    ({ type: FETCH_ALERT_TEMPLATES.REQUEST, payload: filters });

export const fetchAlertTemplatesSuccess = (templates) =>
    ({ type: FETCH_ALERT_TEMPLATES.SUCCESS, payload: templates });

export const fetchAlertTemplatesFailure = (error) =>
    ({ type: FETCH_ALERT_TEMPLATES.FAILURE, payload: error });

export const fetchGeneralTemplatesRequest = () =>
    ({ type: FETCH_GENERAL_TEMPLATES.REQUEST });

export const fetchGeneralTemplatesSuccess = (templates) =>
    ({ type: FETCH_GENERAL_TEMPLATES.SUCCESS, payload: templates });

export const fetchGeneralTemplatesFailure = (error) =>
    ({ type: FETCH_GENERAL_TEMPLATES.FAILURE, payload: error });

export const createAlertTemplateRequest = (templateData) =>
    ({ type: CREATE_ALERT_TEMPLATE.REQUEST, payload: templateData });

export const createAlertTemplateSuccess = (template) =>
    ({ type: CREATE_ALERT_TEMPLATE.SUCCESS, payload: template });

export const createAlertTemplateFailure = (error) =>
    ({ type: CREATE_ALERT_TEMPLATE.FAILURE, payload: error });

export const updateAlertTemplateRequest = (templateId, templateData) =>
    ({ type: UPDATE_ALERT_TEMPLATE.REQUEST, payload: { templateId, templateData } });

export const updateAlertTemplateSuccess = (template) =>
    ({ type: UPDATE_ALERT_TEMPLATE.SUCCESS, payload: template });

export const updateAlertTemplateFailure = (error) =>
    ({ type: UPDATE_ALERT_TEMPLATE.FAILURE, payload: error });

export const deleteAlertTemplateRequest = (templateId) =>
    ({ type: DELETE_ALERT_TEMPLATE.REQUEST, payload: { templateId } });

export const deleteAlertTemplateSuccess = (templateId) =>
    ({ type: DELETE_ALERT_TEMPLATE.SUCCESS, payload: { templateId } });

export const deleteAlertTemplateFailure = (error) =>
    ({ type: DELETE_ALERT_TEMPLATE.FAILURE, payload: error });

// ==================== UI STATE ====================

export const setTaskAlertFilters = (filters) =>
    ({ type: SET_TASK_ALERT_FILTERS, payload: filters });

export const clearTaskAlertDetail = () =>
    ({ type: CLEAR_TASK_ALERT_DETAIL });
